import AccountCard from "@/components/features/account/account-card/accountCard";
import {
  Box,
  Button,
  Drawer,
  Flex,
  Group,
  Image,
  NumberInput,
  rem,
  Select,
  Space,
  Stack,
  Text,
} from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { IconCalendar } from "@tabler/icons-react";
import ImgArrows from "@/assets/images/pngs/arrows.png";
import { UseFormReturnType } from "@mantine/form";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  opened: boolean;
  onClose: () => void;
  onSubmit: (value: any) => void;
  form: UseFormReturnType<any>;
  title?: string;
  type?: "history" | "rollover";
  accountName?: string;
  accountNo?: string;
}
const FilterDrawer = ({
  opened,
  onClose,
  onSubmit,
  form,
  title,
  type,
  accountName,
  accountNo,
}: Props) => {
  const { t } = useTranslation();

  const submitForm = (values: any) => {
    onSubmit(values);
  };
  const toDateRef = useRef<HTMLInputElement>(null);
  const fromDateRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!opened) {
      form.reset();
    }
  }, [opened]);
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      title={t("TRANSACTION_HISTORY_FILTER")}
      withCloseButton
      position="right"
      size={548}
      styles={{
        title: { fontWeight: 500 },
        header: { borderBottom: "1px solid #e0e0e0" },
      }}
    >
      {/* Drawer content */}
      <form onSubmit={form.onSubmit(submitForm)}>
        <Space h={16} />

        <AccountCard description={accountName} title={accountNo} />
        <Stack spacing={20} mt={20}>
          <Box>
            <Text>{t("SELECT_TRANSACTION_PERIOD")}</Text>
            <Flex gap={12} align="center">
              <DateInput
                ref={fromDateRef}
                placeholder={t("FROM_LABEL")}
                rightSection={
                  <IconCalendar
                    size={16}
                    onClick={() => fromDateRef.current?.focus()}
                  />
                }
                radius={8}
                valueFormat="YYYY-MM-DD"
                w="42%"
                {...form.getInputProps("fromDate")}
              />
              <Box>
                <Image src={ImgArrows} alt="arrows" />
              </Box>
              <DateInput
                ref={toDateRef}
                placeholder={t("TO")}
                valueFormat="YYYY-MM-DD"
                rightSection={
                  <IconCalendar
                    size={16}
                    onClick={() => toDateRef.current?.focus()}
                  />
                }
                radius={8}
                w="42%"
                styles={{
                  rightSection: { fontSize: "12px", marginRight: "6px" },
                }}
                {...form.getInputProps("toDate")}
              />
            </Flex>
          </Box>

          <Box>
            <Text>{t("TRANSACTION_VALUE")}</Text>
            <Flex gap={12} align="center">
              <NumberInput
                placeholder={t("FROM_LABEL")}
                rightSection="VND"
                radius={8}
                type="number"
                w="42%"
                styles={{
                  rightSection: { fontSize: "12px", marginRight: "6px" },
                }}
                {...form.getInputProps("fromAmount")}
              />
              <Box>
                <Image src={ImgArrows} alt="arrows" />
              </Box>
              <NumberInput
                placeholder={t("TO")}
                rightSection="VND"
                radius={8}
                type="number"
                w="42%"
                styles={{
                  rightSection: { fontSize: "12px", marginRight: "6px" },
                }}
                {...form.getInputProps("toAmount")}
              />
            </Flex>
          </Box>
          {type === "history" && (
            <Select
              data={[
                { label: t("CASH_INPUT"), value: "INCOMING" },
                { label: t("CASH_OUTPUT"), value: "OUTGOING" },
              ]}
              label={t("CURRENCY_TYPE")}
              placeholder={t("SELECT_CURRENCY_TYPE")}
              radius={8}
              {...form.getInputProps("isIncoming")}
            />
          )}
        </Stack>

        <Group position="center" mt={rem(20)}>
          <Box
            style={{
              position: "fixed",
              bottom: 0,
              right: 0,
              width: "100%",
              padding: "10px 16px",
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              boxShadow: "0px 5px 15px 0px #00000026",
              height: "76px",
              alignItems: "center",
              backgroundColor: "white",
              zIndex: 1,
            }}
          >
            <Flex gap={10}>
              <Button
                onClick={() => form.reset()}
                sx={() => ({
                  width: "100px",
                  backgroundColor: "#F4F4F6",
                  color: "#525866",
                  borderRadius: "8px",
                  padding: "8px 10px",
                  cursor: "pointer",
                  fontWeight: 400,
                  "&:hover": {
                    backgroundColor: "#F4F4F6",
                  },
                })}
              >
                {t("RESET")}
              </Button>
              <Button
                type="submit"
                sx={() => ({
                  width: "160px",
                  backgroundColor: "#2A81D0",
                  color: "white",
                  borderRadius: "8px",
                  padding: "8px 10px",
                  cursor: "pointer",
                  fontWeight: 400,
                })}
              >
                {t("SEARCH")}
              </Button>
            </Flex>
          </Box>
        </Group>
      </form>
    </Drawer>
  );
};
export default FilterDrawer;
